(() => {
  const STORAGE_KEY = "cj_shortlist_v1";
  const MAX_ITEMS = 50;

  function readList() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(handles) {
    const clean = [...new Set(handles)].slice(0, MAX_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(clean));
    return clean;
  }

  function addHandle(handle) {
    const list = readList();
    if (!list.includes(handle)) list.unshift(handle);
    return writeList(list);
  }

  function removeHandle(handle) {
    const list = readList().filter((h) => h !== handle);
    return writeList(list);
  }

  function count() {
    return readList().length;
  }

  function setButtonState(btn, isSaved) {
    if (!btn) return;
    btn.dataset.saved = isSaved ? "true" : "false";
    btn.textContent = isSaved ? "Saved ✓" : "Add to shortlist";
    btn.classList.toggle("button--primary", isSaved);
    btn.classList.toggle("button--secondary", !isSaved);
  }

  function updateViewLinks() {
    const n = count();
    document.querySelectorAll("[data-shortlist-count]").forEach((el) => (el.textContent = String(n)));
    document.querySelectorAll("[data-shortlist-view]").forEach((a) => {
      a.hidden = n === 0;
    });
  }

  function initAddButtons() {
    const buttons = document.querySelectorAll("[data-shortlist-add][data-product-handle]");
    if (!buttons.length) return;

    const list = readList();
    buttons.forEach((btn) => {
      const handle = btn.getAttribute("data-product-handle");
      setButtonState(btn, list.includes(handle));

      btn.addEventListener("click", () => {
        const current = readList();
        const isSaved = current.includes(handle);

        if (isSaved) {
          removeHandle(handle);
          setButtonState(btn, false);
        } else {
          addHandle(handle);
          setButtonState(btn, true);
        }

        updateViewLinks();
        document.dispatchEvent(new CustomEvent("cj:shortlist:changed"));
      });
    });

    updateViewLinks();
  }

  async function fetchProduct(handle) {
    const res = await fetch(`/products/${handle}.js`, { credentials: "same-origin" });
    if (!res.ok) throw new Error(`Failed to fetch product: ${handle}`);
    return await res.json();
  }

function addWidthParam(url, width) {
  if (!url) return "";
  // Keep existing query params (like ?v=123) and add width safely
  return url.includes("?") ? `${url}&width=${width}` : `${url}?width=${width}`;
}

function formatItem(product) {
  return {
    handle: product.handle,
    title: product.title,
    url: product.url,
    image: addWidthParam(product.featured_image, 160),
    vendor: product.vendor,
  };
}

  function escapeHtml(s) {
    return String(s)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  async function renderShortlistPage() {
    const root = document.querySelector("[data-shortlist-page]");
    if (!root) return;

    const listEl = root.querySelector("[data-shortlist-items]");
    const emptyEl = root.querySelector("[data-shortlist-empty]");
    const actionsEl = root.querySelector("[data-shortlist-actions]");
    const copyBtn = root.querySelector("[data-shortlist-copy]");
    const clearBtn = root.querySelector("[data-shortlist-clear]");
    const emailLink = root.querySelector("[data-shortlist-email]");

    async function refresh() {
      const handles = readList();
      updateViewLinks();

      if (!handles.length) {
        listEl.innerHTML = "";
        emptyEl.hidden = false;
        actionsEl.hidden = true;
        return;
      }

      emptyEl.hidden = true;
      actionsEl.hidden = false;

      // Fetch product data (sequential to be kind to the browser)
      const items = [];
      for (const h of handles) {
        try {
          const p = await fetchProduct(h);
          items.push(formatItem(p));
        } catch (e) {
          // If a product no longer exists, drop it from the shortlist silently
          removeHandle(h);
        }
      }

      // Render
      listEl.innerHTML = items
        .map((it) => {
          const img = it.image ? `<img src="${escapeHtml(it.image)}" alt="${escapeHtml(it.title)}" loading="lazy">` : "";
          return `
            <div class="cj-shortlist__item" data-handle="${escapeHtml(it.handle)}">
              <a class="cj-shortlist__media" href="${escapeHtml(it.url)}">${img}</a>
              <div class="cj-shortlist__meta">
                <a class="cj-shortlist__title" href="${escapeHtml(it.url)}">${escapeHtml(it.title)}</a>
                <div class="cj-shortlist__sub">Made to order • Compare in person</div>
                <button type="button" class="cj-shortlist__remove" data-shortlist-remove>Remove</button>
              </div>
            </div>
          `;
        })
        .join("");

      // Remove handlers
      listEl.querySelectorAll("[data-shortlist-remove]").forEach((btn) => {
        btn.addEventListener("click", (e) => {
          const wrap = e.target.closest("[data-handle]");
          const handle = wrap?.getAttribute("data-handle");
          if (!handle) return;
          removeHandle(handle);
          refresh();
          document.dispatchEvent(new CustomEvent("cj:shortlist:changed"));
        });
      });

      // Copy
      if (copyBtn) {
        copyBtn.onclick = async () => {
          const text = items
            .map((it) => `• ${it.title}\n  ${location.origin}${it.url}`)
            .join("\n\n");
          try {
            await navigator.clipboard.writeText(text);
            copyBtn.textContent = "Copied ✓";
            setTimeout(() => (copyBtn.textContent = "Copy shortlist"), 1400);
          } catch (e) {
            copyBtn.textContent = "Copy failed (browser)";
            setTimeout(() => (copyBtn.textContent = "Copy shortlist"), 1600);
          }
        };
      }

      // Clear
      if (clearBtn) {
        clearBtn.onclick = () => {
          writeList([]);
          refresh();
          document.dispatchEvent(new CustomEvent("cj:shortlist:changed"));
        };
      }

      // Email (mailto fallback)
      if (emailLink) {
        const body = encodeURIComponent(
          items.map((it) => `• ${it.title}\n${location.origin}${it.url}`).join("\n\n")
        );
        emailLink.href = `mailto:info@champaignjewelers.com?subject=${encodeURIComponent("My Lashbrook shortlist")}&body=${body}`;
      }
    }

    // Refresh on load + whenever list changes
    refresh();
    document.addEventListener("cj:shortlist:changed", refresh);
  }

  document.addEventListener("DOMContentLoaded", () => {
    initAddButtons();
    renderShortlistPage();

    // Update header counters if you add them later
    updateViewLinks();
  });
})();
